/**
 * Resolve the REST API base URL (PX-W6.1).
 *
 * - `VITE_API_BASE_URL` is the override. If set (non-empty), use it verbatim.
 * - Otherwise: same-origin in production (`/api/v1`, served by the Play host
 *   that serves the SPA bundle), and the PX dev backend
 *   (`http://localhost:9112`) in development.
 *
 * The CI sets `VITE_API_BASE_URL=""` to force same-origin in the prod bundle.
 * `""` is falsy, so the legacy `env || fallback` pattern always landed on the
 * dev fallback in prod. Use this helper at every call site instead of inlining
 * the `||` fallback (mirrors xelerate-ai's `services/apiBaseUrl.ts`).
 */
export function getApiBaseUrl(): string {
  const raw = (import.meta.env.VITE_API_BASE_URL ?? '').trim()
  if (raw.length > 0) return raw
  return import.meta.env.DEV ? 'http://localhost:9112/api/v1' : '/api/v1'
}
